export default __webpack_public_path__ + "static/media/dus_dark.7d90e89c.png";